  document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('priceInquiryForm');
    const inquiryBtn = document.getElementById('inquirySubmit');
    const notifyBtn = document.getElementById('notifySubmit');

    // Handle inquiry button click
    inquiryBtn.addEventListener('click', function(e) {
      e.preventDefault();

      const selectVariant = document.getElementById('inquiryVariant');
      const selectedVariant = selectVariant.options[selectVariant.selectedIndex].text;
      
      const formData = new FormData();
      formData.append('name', document.getElementById('inquiryName').value);
      formData.append('email', document.getElementById('inquiryEmail').value);
      formData.append('phone', document.getElementById('inquiryPhone').value);
      formData.append('message', document.getElementById('inquiryMessage').value);
      formData.append('variant_name', selectedVariant || '');
      formData.append('variant_id', document.getElementById('inquiryVariant')?.value || '');
      formData.append('product_title', document.getElementById('inquiryTitle')?.value || '');
      formData.append('product_sku', document.getElementById('inquirySku')?.value || '');
      formData.append('request_type', 'inquiry');

      const data = {};
      formData.forEach((value, key) => {
        data[key] = value;
      });

      inquiryBtn.disabled = true;
      inquiryBtn.textContent = 'Sending...';
      
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = 'https://hooks.zapier.com/hooks/catch/5229910/25y8mpe/';
      form.target = 'post_iframe';

      Object.entries(data).forEach(([key, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = value;
        form.appendChild(input);
      });

      const iframe = document.createElement('iframe');
      iframe.name = 'post_iframe';
      iframe.style.display = 'none';
      document.body.appendChild(iframe);

      document.body.appendChild(form);
      form.submit();

      setTimeout(() => {
        showPriceInquiryResponseMessage('Thank you for your inquiry! We will get back to you soon.', 'success');
        resetPriceInquiryForm(); // Updated this line
        inquiryBtn.disabled = false;
        inquiryBtn.textContent = 'Inquire';
        document.body.removeChild(form);
        document.body.removeChild(iframe);
      }, 1000);
    });

    // Handle notify button click
    notifyBtn.addEventListener('click', function(e) {
      e.preventDefault();
      
      const email = document.getElementById('inquiryEmail').value;
      const variantId = document.getElementById('inquiryVariant')?.value;

      if (!email) {
        showPriceInquiryResponseMessage('Please enter your email address', 'error');
        return;
      }

      if (!variantId) {
        showPriceInquiryResponseMessage('Please select a variant', 'error');
        return;
      }

      const formData = new FormData();
      formData.append('email', email);
      formData.append('variant_id', variantId);
      formData.append('product_title', document.getElementById('inquiryTitle')?.value || '');
      formData.append('product_sku', document.getElementById('inquirySku')?.value || '');
      formData.append('request_type', 'notification');

      const data = {};
      formData.forEach((value, key) => {
        data[key] = value;
      });

      notifyBtn.disabled = true;
      notifyBtn.textContent = 'Sending...';

      const form = document.createElement('form');
      form.method = 'POST';
      form.action = 'https://hooks.zapier.com/hooks/catch/5229910/25y8mpe/';
      form.target = 'post_iframe_notify';

      Object.entries(data).forEach(([key, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = value;
        form.appendChild(input);
      });

      const iframe = document.createElement('iframe');
      iframe.name = 'post_iframe_notify';
      iframe.style.display = 'none';
      document.body.appendChild(iframe);

      document.body.appendChild(form);
      form.submit();

      setTimeout(() => {
        showPriceInquiryResponseMessage('You will be notified when this item becomes available', 'success');
        resetPriceInquiryForm(); // Added this line
        notifyBtn.disabled = false;
        notifyBtn.textContent = 'Notify When Available';
        document.body.removeChild(form);
        document.body.removeChild(iframe);
      }, 1000);
    });
  });

  function showPriceInquiryResponseMessage(message, type) {
    const responseDiv = document.getElementById('priceInquiryResponseMessage');
    if (!responseDiv) return;
    
    responseDiv.textContent = message;
    responseDiv.className = 'price-inquiry-response-message ' + type;
    responseDiv.style.display = 'block';
    
    responseDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
    
    setTimeout(function() {
      responseDiv.style.display = 'none';
    }, 5000);
  }

  function resetPriceInquiryForm() {
    document.getElementById('inquiryName').value = '';
    document.getElementById('inquiryEmail').value = '';
    document.getElementById('inquiryPhone').value = '';
    document.getElementById('inquiryMessage').value = '';
    if (document.getElementById('inquiryVariant')) {
      document.getElementById('inquiryVariant').selectedIndex = 0;
    }
  }

  const style = document.createElement('style');
  style.textContent = `
    .price-inquiry-response-message {
      padding: 10px;
      margin: 10px 0;
      border-radius: 4px;
      text-align: center;
    }
    
    .price-inquiry-response-message.success {
      background-color: #d4edda;
      color: #155724;
      border: 1px solid #c3e6cb;
    }
    
    .price-inquiry-response-message.error {
      background-color: #f8d7da;
      color: #721c24;
      border: 1px solid #f5c6cb;
    }
  `;
  document.head.appendChild(style);
